import { Box, IconButton, Menu, MenuItem, Tab, Tabs } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import SearchBar from '../../components/SearchBar';
import TableComponent from '../../components/TableComponent';
import { errorToast, showWarning } from '../../helpers';
import MainContainer from '../../layout/MainContainer';
import { InspectionDetailModal, InspectionReportModal } from '../../Modals';
import {
  useLazyGetInspectionQuery,
  useLazyGwtInspectionByIdQuery,
  useUploadReportMutation,
} from '../../service/inspectionRequest';
import { CommonBody } from '../../types/General';
import { generateEncryptedKeyBody } from '../../utils/crypto';
import { VEHICLE_TYPE } from '../../utils/enums';
import { Uploadpdf } from '../../utils/mediaUpload';
import { isValidInput } from '../../utils/validations';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}
enum TabPanelState {
  NEW_REQUESTS = 1,
  RESOLVED_REQUESTS = 2,
}
function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const InspectionRequests = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const [openDetail, setOpenDetail] = useState(false);
  const [valueTabs, setValueTabs] = React.useState(0);
  const [openUpload, setOpenUpload] = useState(false);
  const [pdfFile, setPdfFile] = useState<File | null>(null);
  const [getInspection] = useLazyGetInspectionQuery();
  const [getInspectionById] = useLazyGwtInspectionByIdQuery();
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState<number>(1);
  const [selectedInspection, setSelectedInspection] = useState<string>('');
  const [count, setCount] = useState(0);
  const handlePageChange = (event: any, newPage: number) => {
    setPage(newPage + 1);
  };
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>('');
  const [inspectionDetails, setInspectionDetails] = useState<any>(null);
  const [hidden, setHidden] = useState<string[]>([]);
  const [anchorEl1, setAnchorEl1] = React.useState<null | HTMLElement>(null);
  const [rows, setRows] = useState<any>([]);
  const [selectedId, setSelectedId] = useState<string>('');
  const [uploadRepoart] = useUploadReportMutation();
  const [reportUrl, setReportUrl] = useState<string>('');

  const handlePdfUpload = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    const file = files?.length ? files[0] : null;

    if (!file) {
      setReportUrl('');
      return;
    }
    if (file.type !== 'application/pdf') {
      showWarning('Please upload a valid PDF file.');
      return;
    }
    try {
      const uploadResponse = (await Uploadpdf(file)) as any;
      if (uploadResponse?.statusCode === 200) {
        setReportUrl(uploadResponse?.data?.image);
        setPdfFile(file);
      }
    } catch (error) {
      console.error('PDF upload error:', error);
    }
  };

  const handleUploadReport = async () => {
    if (!reportUrl) {
      showWarning('Please upload a PDF file.');
      return;
    }
    setLoading(true);
    const body = {
      inspectionReport: reportUrl,
    };

    try {
      const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;
      const response = await uploadRepoart({
        id: selectedId,
        body: encryptedBody,
      }).unwrap();
      if (response?.statusCode === 200) {
        setValueTabs(1);
        setOpenUpload(false);
        setPdfFile(null);
        setReportUrl('');
        fetchInspection();
      } else {
        errorToast(response?.message || 'Something went wrong');
      }
    } catch (error: any) {
      errorToast(error?.data?.message || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  const fetchInspection = async () => {
    setLoading(true);
    try {
      const response = await getInspection({
        page: page,
        limit: 10,
        // search:debouncedSearchTerm,
        statusType: valueTabs === 0 ? TabPanelState.NEW_REQUESTS : TabPanelState.RESOLVED_REQUESTS,
      }).unwrap();
      if (response?.statusCode === 200) {
        setRows(response?.data?.data || []);
        setCount(response?.data?.count || 0);
      } else {
        setRows([]);
      }
    } catch (error: any) {
      errorToast(error?.data?.message || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setOpenDetail(false);
  };

  const handleViewInspection = async () => {
    setOpenDetail(true);
    try {
      const response = await getInspectionById({ id: selectedId }).unwrap();
      if (response?.statusCode === 200) {
        setInspectionDetails(response?.data || []);
      } else {
        setRows([]);
      }
    } catch (error: any) {
      errorToast(error?.data?.message || 'Something went wrong');
    }
  };
  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
    setPage(1);
    setRows([]);
    // fetchInspection();
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file && file.type === 'application/pdf') {
      setPdfFile(file);
    } else {
      alert('Please upload a valid PDF file.');
    }
  };
  const handleDrop = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    const file = event.dataTransfer.files?.[0];
    if (file && file.type === 'application/pdf') {
      setPdfFile(file);
    } else {
      alert('Please upload a valid PDF file.');
    }
  };

  const open1 = Boolean(anchorEl1);

  const handleClick1 = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl1(event.currentTarget);
  };
  const handleClose1 = () => {
    setAnchorEl1(null);
  };
  const label = { inputProps: { 'aria-label': 'Switch demo' } };

  const columns: GridColDef<(typeof rows)[number]>[] = [
    {
      flex: 0.1,
      minWidth: 150,
      field: 'requestDate',
      headerName: 'Request Date',
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="sq_image" style={{ marginTop: '16px' }}>
            {moment(row?.createdAt).format('YYYY-MM-DD') || '-'}
          </div>
        );
      },
    },
    {
      flex: 0.6,
      minWidth: 250,
      field: 'vehicle',
      headerName: 'Vehicle Details',
      editable: false,
      sortable: false,

      renderCell: ({ row }) => {
        return (
          <div className="sq_image" style={{ marginTop: '16px' }}>
            <figure
              style={{ cursor: 'pointer' }}
              onClick={() => navigate(`/listing-detail/${row?.vehicleType}/${row?._id}`)}
            >
              <img src={row?.image[0]} alt={row?.title} />
            </figure>
            <p>
              {/* #CR00001<b>{row?.title}</b> */}
              {row?.vehicleBrand}
              <b>{row?.title}</b>
            </p>
          </div>
        );
      },
    },
    {
      flex: 0.4,
      minWidth: 150,
      field: 'vehicleType',
      headerName: 'Vehicle Type',
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>
              <b>
                {row?.vehicleType === VEHICLE_TYPE.CAR
                  ? 'Car'
                  : row?.vehicleType === VEHICLE_TYPE.BIKE
                    ? 'Bike'
                    : row?.vehicleType === VEHICLE_TYPE.TRUCK
                      ? 'Truck'
                      : row?.vehicleType === VEHICLE_TYPE.HEAVY_VEHICLE
                        ? 'Heavy Vehicle'
                        : '- -'}
              </b>
            </p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 250,
      field: 'name',
      headerName: 'User Details',
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <figure>
              <img src={row?.userImage} alt="" />
            </figure>
            <p>
              <b>{row?.userName}</b>
              {row?.userDialCode} {row?.userPhoneNo} <br />
              {row?.userEmail}
            </p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 250,
      field: 'sellerDetails',
      headerName: 'Seller Details',
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <figure>
              <img src={row?.sellerImage} alt="" />
            </figure>
            <p>
              <b>{row?.sellerName}</b>
              {row?.sellerDialCode} {row?.sellerPhoneNo} <br />
              {row?.sellerEmail}
            </p>
          </div>
        );
      },
    },
    {
      flex: 0.2,
      minWidth: 150,
      field: 'address',
      headerName: 'Seller Address',
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>{row?.sellerAddress?.address || '-'}</p>
          </div>
        );
      },
    },

    {
      flex: 0.1,
      minWidth: 80,
      field: 'action',
      headerName: 'Action',
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="table_actions">
            <Box>
              <IconButton
                aria-controls={open1 ? 'basic-menu1' : undefined}
                aria-haspopup="true"
                aria-expanded={open1 ? 'true' : undefined}
                onClick={(e) => {
                  handleClick1(e);
                  setSelectedId(row._id);
                }}
              >
                <img src="/static/images/more_icon.svg" alt="" />
              </IconButton>
              <Menu
                className="setting_menu"
                id="basic-menu1"
                anchorEl={anchorEl1}
                open={open1}
                onClose={handleClose1}
                MenuListProps={{
                  'aria-labelledby': 'basic-button1',
                }}
                PaperProps={{
                  elevation: 0,
                  sx: {
                    overflow: 'visible',
                    boxShadow: '0px 4px 20px 0px rgba(0, 0, 0, 0.05)',
                    borderRadius: '8px',
                    mt: 1,
                  },
                }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
              >
                <MenuItem
                  onClick={() => {
                    handleViewInspection();
                  }}
                >
                  View
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    setOpenUpload(true);
                    handleClose1();
                  }}
                >
                  Upload Report
                </MenuItem>
              </Menu>
            </Box>
          </div>
        );
      },
    },
  ];
  const columnsInspected: GridColDef<(typeof rows)[number]>[] = [
    {
      flex: 0.1,
      minWidth: 150,
      field: 'requestDate',
      headerName: 'Request Date',
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="sq_image" style={{ marginTop: '16px' }}>
            {moment(row?.createdAt).format('YYYY-MM-DD') || '-'}
          </div>
        );
      },
    },
    {
      flex: 0.6,
      minWidth: 250,
      field: 'vehicle',
      headerName: 'Vehicle Details',
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="sq_image" style={{ marginTop: '16px' }}>
            <figure
              style={{ cursor: 'pointer' }}
              onClick={() => navigate(`/listing-detail/${row?.vehicleType}`)}
            >
              <img src={row?.image[0]} alt="" />
            </figure>
            <p>
              {row?.vehicleBrand}
              <b>{row?.title}</b>
            </p>
          </div>
        );
      },
    },
    {
      flex: 0.4,
      minWidth: 200,
      field: 'vehicleType',
      headerName: 'Vehicle Type',
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>
              <b>
                {row?.vehicleType === VEHICLE_TYPE.CAR
                  ? 'Car'
                  : row?.vehicleType === VEHICLE_TYPE.BIKE
                    ? 'Bike'
                    : row?.vehicleType === VEHICLE_TYPE.TRUCK
                      ? 'Truck'
                      : row?.vehicleType === VEHICLE_TYPE.HEAVY_VEHICLE
                        ? 'Heavy Vehicle'
                        : '- -'}
              </b>
            </p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 250,
      field: 'name',
      headerName: 'User Details',
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <figure>
              <img src={row?.userImage} alt={row?.title} />
            </figure>
            <p>
              <b>{row?.userName}</b> {row?.userDialCode} {row?.userPhoneNo} <br />
              {row?.userEmail}
            </p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 250,
      field: 'sellerDetails',
      headerName: 'Seller Details',
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <figure>
              <img src={row?.sellerImage} alt="seller-image" />
            </figure>
            <p>
              <b>{row?.sellerName}</b>
              {row?.sellerDialCode} {row?.sellerPhoneNo} <br />
              {row?.sellerEmail}
            </p>
          </div>
        );
      },
    },
    {
      flex: 0.2,
      minWidth: 150,
      field: 'address',
      headerName: 'Seller Address',
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>{row?.sellerAddress?.address || '-'}</p>
          </div>
        );
      },
    },

    {
      flex: 0.1,
      minWidth: 80,
      field: 'action',
      headerName: 'Action',
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="table_actions">
            <Box>
              <IconButton
                aria-controls={open1 ? 'basic-menu1' : undefined}
                aria-haspopup="true"
                aria-expanded={open1 ? 'true' : undefined}
                onClick={(e) => {
                  handleClick1(e);
                  setSelectedId(row._id);
                }}
              >
                <img src="/static/images/more_icon.svg" alt="" />
              </IconButton>
              <Menu
                className="setting_menu"
                id="basic-menu1"
                anchorEl={anchorEl1}
                open={open1}
                onClose={handleClose1}
                MenuListProps={{
                  'aria-labelledby': 'basic-button1',
                }}
                PaperProps={{
                  elevation: 0,
                  sx: {
                    overflow: 'visible',
                    boxShadow: '0px 4px 20px 0px rgba(0, 0, 0, 0.05)',
                    borderRadius: '8px',
                    mt: 1,
                  },
                }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
              >
                <MenuItem
                  onClick={() => {
                    handleViewInspection();
                  }}
                >
                  View
                </MenuItem>

                <MenuItem onClick={handleClose1}>Initiate Refund</MenuItem>
              </Menu>
            </Box>
          </div>
        );
      },
    },
  ];

  useEffect(() => {
    fetchInspection();
  }, [page, valueTabs, debouncedSearchTerm]);
  return (
    <MainContainer>
      <div className="main_title">
        <h1> Inspection Requests</h1>
        <p>
          <span onClick={() => navigate('/dashboard')}>Dashboard</span> - Inspection Requests
        </p>
      </div>

      <div className="cards">
        <Box className="custom_tabs" sx={{ width: '100%' }}>
          <div className="table_header">
            <div className="left_s">
              <Box className="search_box">
                <SearchBar
                  searchTerm={searchTerm}
                  placeholder="Search"
                  setDebouncedSearchTerm={setDebouncedSearchTerm}
                  value={searchTerm}
                  onCross={() => setSearchTerm('')}
                  onChange={(val: any) => {
                    if (isValidInput(val.target.value)) {
                      setSearchTerm(val.target.value);
                    }
                  }}
                />
              </Box>
            </div>
          </div>
          <Tabs
            value={valueTabs}
            onChange={handleChangeTabs}
            aria-label="basic tabs example"
            className="custom_tabs_links"
          >
            <Tab label="New Requests" {...a11yProps(0)} />
            <Tab label="Resolved Requests" {...a11yProps(1)} />
          </Tabs>
          <CustomTabPanel value={valueTabs} index={0}>
            <div className="sorting_table">
              <TableComponent
                count={count}
                onPageChange={handlePageChange}
                page={page}
                loading={loading}
                columns={columns?.filter((item: any) => !hidden.includes(item.field))}
                rows={rows}
              />
            </div>
          </CustomTabPanel>
          <CustomTabPanel value={valueTabs} index={1}>
            <div className="sorting_table">
              <TableComponent
                count={count}
                onPageChange={handlePageChange}
                loading={loading}
                columns={columnsInspected?.filter((item: any) => !hidden.includes(item.field))}
                rows={rows}
              />
            </div>
          </CustomTabPanel>
        </Box>

        <InspectionDetailModal
          open={openDetail}
          setOpen={setOpenDetail}
          onClose={handleClose}
          details={inspectionDetails}
        />
        <InspectionReportModal
          open={openUpload}
          setOpen={setOpenUpload}
          onClose={() => setOpenUpload(false)}
          pdfFile={pdfFile}
          setPdfFile={setPdfFile}
          handleFileChange={handleFileChange}
          handleDrop={handleDrop}
          handlePdfUpload={handlePdfUpload}
          handleSubmit={handleUploadReport}
        />
      </div>
    </MainContainer>
  );
};

export default InspectionRequests;
